(function () {
  'use strict';

  var loading = false;
  var scrollObserver = null;
  var gridWatcher = null;

  function getContainer() {
    return document.getElementById('ProductGridContainer');
  }

  function getSentinel(container) {
    return container && container.querySelector('[data-tt-infinite-scroll]');
  }

  function getGrid(container) {
    return container && container.querySelector('#product-grid');
  }

  function disconnectScroll() {
    if (scrollObserver) {
      scrollObserver.disconnect();
      scrollObserver = null;
    }
  }

  function productKey(card) {
    var link = card.querySelector('a[href*="/products/"]');
    return link ? link.getAttribute('href').split('?')[0] : null;
  }

  function existingKeys(grid) {
    var keys = Object.create(null);
    Array.prototype.forEach.call(grid.children, function (child) {
      var key = productKey(child);
      if (key) keys[key] = true;
    });
    return keys;
  }

  function setBusy(sentinel, isBusy) {
    loading = isBusy;
    var loadingEl = sentinel.querySelector('.tt-infinite-scroll__loading');
    if (loadingEl) loadingEl.hidden = !isBusy;
    sentinel.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  }

  function markComplete(sentinel) {
    sentinel.dataset.nextUrl = '';
    sentinel.dataset.hasMore = 'false';
    var endEl = sentinel.querySelector('.tt-infinite-scroll__end');
    if (endEl) endEl.hidden = false;
    disconnectScroll();
  }

  function updateNextFromDoc(container, sentinel, doc) {
    var nextSentinel = doc.querySelector('[data-tt-infinite-scroll]');
    if (nextSentinel && nextSentinel.dataset.hasMore === 'true' && nextSentinel.dataset.nextUrl) {
      sentinel.dataset.nextUrl = nextSentinel.dataset.nextUrl;
      sentinel.dataset.hasMore = 'true';
      return true;
    }

    var nextLink = doc.querySelector('#ProductGridContainer a.pagination__item--prev');
    if (nextLink && nextLink.getAttribute('href')) {
      sentinel.dataset.nextUrl = nextLink.href;
      sentinel.dataset.hasMore = 'true';
      return true;
    }

    return false;
  }

  function syncPagination(container, doc) {
    var oldPag = container.querySelector('.pagination-wrapper');
    var newPag = doc.querySelector('#ProductGridContainer .pagination-wrapper');
    if (oldPag && newPag) {
      oldPag.replaceWith(document.importNode(newPag, true));
    } else if (oldPag && !newPag) {
      oldPag.remove();
    }
  }

  function loadNext(container) {
    var sentinel = getSentinel(container);
    var grid = getGrid(container);
    if (!sentinel || !grid || loading) return;
    if (sentinel.dataset.hasMore !== 'true' || !sentinel.dataset.nextUrl) {
      markComplete(sentinel);
      return;
    }

    var nextUrl = sentinel.dataset.nextUrl;
    setBusy(sentinel, true);

    fetch(nextUrl)
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to load next page');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nextGrid = doc.getElementById('product-grid');
        if (!nextGrid) {
          markComplete(sentinel);
          return;
        }

        var keys = existingKeys(grid);
        Array.prototype.forEach.call(nextGrid.children, function (child) {
          var key = productKey(child);
          if (key && keys[key]) return;
          if (key) keys[key] = true;
          grid.appendChild(document.importNode(child, true));
        });

        syncPagination(container, doc);

        if (!updateNextFromDoc(container, sentinel, doc)) {
          markComplete(sentinel);
        }
      })
      .catch(function () {
        document.documentElement.classList.remove('tt-infinite-enabled');
        disconnectScroll();
      })
      .finally(function () {
        setBusy(sentinel, false);
      });
  }

  function setup() {
    disconnectScroll();
    var container = getContainer();
    if (!container) return;

    var sentinel = getSentinel(container);
    if (!sentinel) return;

    document.documentElement.classList.add('tt-infinite-enabled');

    if (sentinel.dataset.hasMore !== 'true' || !sentinel.dataset.nextUrl) {
      markComplete(sentinel);
      return;
    }

    scrollObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) loadNext(container);
        });
      },
      { root: null, rootMargin: '600px 0px', threshold: 0 }
    );
    scrollObserver.observe(sentinel);
  }

  function watchForFilterUpdates() {
    var container = getContainer();
    if (!container) return;

    if (!gridWatcher) {
      gridWatcher = new MutationObserver(function () {
        setup();
      });
      gridWatcher.observe(container, { childList: true, subtree: false });
    }

    setup();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchForFilterUpdates);
  } else {
    watchForFilterUpdates();
  }

  document.addEventListener('shopify:section:load', setup);
})();
